import React, {PureComponent, useContext} from 'react';
import {Link} from "react-router-dom";
import axios from "../../../axios-defaults";
import UserContext from '../../../context/user-context';

import {withTranslation} from 'react-i18next';
import Input from "../../UI/Input/Input";
import SubAccountsList from "./SubAccounts";
import {toast} from "react-toastify";
import Spinner from "../../UI/Spinner";

class Form extends PureComponent {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            success: false,
            loading: true,
            subAccountsVisibility: false,
            allSubAccounts: null,
            currentSubAccounts: null,
            subAccounts: null,
            subAccountIds: null,
            subAccountsNames: null,
            userEmail: null,
            accountName: '',
            userPermission: null,
            formIsValid: false,
            itemId: null,
            formTitle: 'profile.assignments.form.title.create',
            formEditTitle: 'profile.assignments.form.title.edit',
            formSubtitle: 'profile.assignments.form.subtitle',
            form: {
                email: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'email',
                        autoComplete: 'email',
                        id: 'email',
                    },
                    label: "profile.assignments.form.email",
                    value: '',
                    validationRules: {
                        required: true,
                        email: true,
                        not_in: []
                    },
                    valid: false,
                    touched: false,
					erroredRules:[],
                    errorMessages: {
						required: "errors.validemail",
						email: "errors.validemail",
						not_in: "errors.already_assigned",
					}
                },
                permissions: {
                    elementType: 'radio',
                    elementConfigs: {
                        type: 'radio',
                        placeholder: '',
                        name: 'permissions',
                        autoComplete: '',
                        id: 'permissions',
                        options: [
                            {
                                value: 'complete',
                                label: 'profile.assignments.permission.complete'
                            },
                            {
                                value: 'limited',
                                label: 'profile.assignments.permission.limited'
                            }]
                    },
                    label: "profile.assignments.form.permission.label",
                    validationRules: {
                        required: true
                    },
                    value: '',
                    valid: false,
                    touched: false,
                    errorMessage: "errors.fieldrequired"
                },
                specific_permissions: {
                    elementType: 'checkbox',
                    elementConfigs: {
                        type: 'checkbox',
                        placeholder: '',
                        name: 'specific_permissions',
                        autoComplete: '',
                        id: 'specific_permissions',
                        options: []
                    },
                    validationRules: {
                        required: false
                    },
                    label: "profile.assignments.form.specific_permissions.label",
                    value: '',
                    valid: true,
                    touched: false,
                    errorMessage: ""
                },
                subaccounts: {
                    elementType: 'hidden',
                    elementConfigs: {
                        type: 'hidden',
                        placeholder: '',
                        name: 'user-subaccounts',
                        autoComplete: '',
                        id: 'user-subaccounts',
                    },
                    label: "",
                    validationRules: {
                        required: true
                    },
                    valid: false,
                    value: '',
                    touched: false,
                    errorMessage: "errors.fieldrequired"
                },

            }
        }
    }

    async componentDidMount() {

        axios.get(`assignments/users`)
            .then((res)=>{
                const form = {...this.state.form};

                form.email.validationRules.not_in = res.data.data.emails
                this.setState({
                    form: form
                });
            })

        const specific_permissions = await axios.get(`/permissions`);

        let permissions_options = [];
        let permissions_options2 = [];
        Object.keys(specific_permissions.data.data.permissions).forEach(function (key) {
            permissions_options[specific_permissions.data.data.permissions[key].id] = {
                value:specific_permissions.data.data.permissions[key].id,
                label:"profile.assignments.form.specific_permissions.key."+specific_permissions.data.data.permissions[key].name,
                selected:false
            };

            permissions_options2.push({
                value:specific_permissions.data.data.permissions[key].id,
                label:"profile.assignments.form.specific_permissions.key."+specific_permissions.data.data.permissions[key].name,
                selected:false
            });
        })

        const form = {...this.state.form};
        form.specific_permissions.elementConfigs.options = permissions_options;
        this.setState({
            form: form
        });

        const id = this.props.match.params.id;

        if (id) {
            this.setState({
                formTitle: this.state.formEditTitle
            });

            const res = await axios.get(`/assignments/${id}/edit`);
            const form = {...this.state.form};

            form.email.value = res.data.data.to_user_email;
            form.email.valid = res.data.data.to_user_email != '';
            form.email.elementConfigs.readOnly = (form.email.valid ? 'readonly' : '');
            form.permissions.value = res.data.data.permission_type;
            form.permissions.valid = res.data.data.permission_type != '';
            form.subaccounts.value = res.data.data.account_codes;
            form.subaccounts.valid = res.data.data.account_codes != '';

            let permission_ids = [];
            Object.keys(res.data.data.permissions).forEach(function (key) {
                permission_ids.push(res.data.data.permissions[key].id.toString());
            })

            Object.keys(form.specific_permissions.elementConfigs.options).forEach(function (key) {
                if (permission_ids.indexOf(key) != -1){
                    form.specific_permissions.elementConfigs.options[key].selected = true;
                }
            })

            let selectedPermissionValues = [];
            Object.entries(form.specific_permissions.elementConfigs.options).forEach(([key, option]) => {
                if (option.selected) {
                    selectedPermissionValues.push(option.value);
                }
            });
            form.specific_permissions.value = selectedPermissionValues;

            this.setState({
                itemId: id,
                subAccountIds: form.subaccounts.value,
                form: form,
                subAccountsVisibility: form.permissions.value == 'limited',
                formIsValid: true
            });
        }

        this.setState({
            loading: false
        });
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {...this.state.form};
        const updatedFormElement = {...updatedForm[inputIdentifier]}

        updatedFormElement.value = event.target.value;
		const {isValid, erroredRule} = this.checkValidity(updatedFormElement.value, updatedFormElement.validationRules);

        updatedFormElement.valid = isValid;
        updatedFormElement.touched = true;
		updatedFormElement.erroredRule = erroredRule;

		if (typeof updatedFormElement.errorMessages === 'object'){
			if (updatedFormElement.erroredRule !== null){
				updatedFormElement.errorMessage = updatedFormElement.errorMessages[updatedFormElement.erroredRule]
			}
		}

        updatedForm[inputIdentifier] = updatedFormElement;

        if (event.target.name == 'permissions') {
            this.setState({
                subAccountsVisibility: event.target.value == 'limited'
            });

            if (event.target.value == 'complete') {
                updatedForm['subaccounts'].valid = true;
            } else {
                updatedForm['subaccounts'].valid = updatedForm['subaccounts'].value != ''
            }
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }

        this.setState({
            form: updatedForm,
            formIsValid: formIsValid
        });
    }

    handleOnCheckedChange = (event) => {
        event.persist();
        const updatedForm = {...this.state.form};
        const updatedFormElement = {...updatedForm[event.target.name]}

        let updatedIndex = null;

		const {isValid} = this.checkValidity(updatedFormElement.value, updatedFormElement.validationRules);
		updatedFormElement.valid = isValid;
        updatedFormElement.touched = true;

        let checkedItems = []
        Object.entries(updatedFormElement.elementConfigs.options).map(item => {
            const key = item[0];
            const option = item[1];
            if (key == event.target.value){
                option.selected = !option.selected;
            }

            if (option.selected){
                checkedItems.push(option.value);
            }
        });

        updatedFormElement.value = checkedItems;
        updatedForm[event.target.name] = updatedFormElement;

        this.setState({
            form : updatedForm
        });
    };

    updateSelectedSubAccounts = (checkedItems, checkedItemsNames) => {
        this.setState({
            subAccountIds: checkedItems,
            subAccountsNames: checkedItemsNames
        });

        let inputIdentifier = 'subaccounts'
        const updatedForm = {...this.state.form};
        const updatedFormElement = {...updatedForm[inputIdentifier]}

        updatedFormElement.value = checkedItems;
        updatedFormElement.names = checkedItemsNames;
		const {isValid} = this.checkValidity(updatedFormElement.value, updatedFormElement.validationRules);
        updatedFormElement.valid = isValid;
        updatedFormElement.touched = true;

        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }

        this.setState({
            form: updatedForm,
            formIsValid: formIsValid
        });
    }

    checkValidity = (value, rules) => {
        let isValid = true;
		let erroredRule = null;
        if (rules.required) {
            if (Array.isArray(value)) {
                isValid = value.length !== 0 && isValid;
            } else {
                isValid = value.trim() !== '' && isValid;
            }

			if (!isValid) erroredRule = 'required'
        }

        if (rules.minLength) {
            isValid = value.length >= rules.minLength && isValid;
			if (!(value.length >= rules.minLength)) erroredRule = 'minLength'
        }

        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
			if (!(value.length <= rules.maxLength)) erroredRule = 'maxLength'
        }

        if (rules.match) {
            isValid = this.state.passwordForm[rules.match].value === value;
        }

        if (rules.email) {
            const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let valid = regex.test(String(value).toLowerCase());

            isValid = valid && isValid
			if (!valid) erroredRule = 'email'
        }

        if (rules.not_in){
            let valid = !rules.not_in.includes(value);
            isValid = valid && isValid
			if (!valid){
				erroredRule = 'not_in';
			}
        }

        return {isValid, erroredRule};
    }

    saveRoleHandler = (e) => {
        e.preventDefault();

        if (!this.state.formIsValid) {
            toast.error(
                <div>
                    <i className="fal fa-exclamation-circle"></i>&nbsp; The change password form is invalid and can't be
                    submitted
                </div>
            );
        }

        this.setState({
            loading: true,
            formIsValid: false
        });

        const {account} =this.context.user;
        const address = [account.address.addressLine1,account.address.city,account.address.stateOrProvinceCode,account.address.postalCode].join(', ')
        const {email, permissions, specific_permissions, subaccounts} = this.state.form;

        if (this.state.itemId) {
            axios.patch('/assignments/' + this.state.itemId,
                {
                    permissions: permissions.value,
                    specific_permissions: specific_permissions.value,
                    subaccounts: subaccounts.value,
                    account_name: account.name,
                    account_address: address
                })
                .then(response => {
                    this.setState({loading: false});
                    if (response.data.succeeded) {
                        toast.success(
                            <div>
                                <i className="fal fa-check-circle"></i>&nbsp;{this.props.t('profile.assignments.form.submit.success.update')}
                            </div>
                        );

                        this.props.history.push('/profile');
                    }
                    if (response.data.errors) {
                        let errorMessages = [];
                        {
                            Object.keys(response.data.errors).forEach(function (key) {
                                errorMessages.push(response.data.errors[key][0]);
                            })
                        }

                        toast.error(
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;
                                <small style={{lineHeight: '1.2', display: 'inline-block'}}>
                                    {errorMessages.join('\n\r')}
                                </small>
                            </div>
                        );
                    }
                }).catch(error => {
                    console.log('[ManageAccount.js] : Change password error in passwordChangedHandler()', error.message);
                    this.setState({loading: false});
                }
            );
        } else {
            axios.post('/assignments',
                {
                    email: email.value,
                    permissions: permissions.value,
                    specific_permissions: specific_permissions.value,
                    subaccounts: subaccounts.value,
                    account_name: account.name,
                    account_address: address
                })
                .then(response => {
                    this.setState({loading: false});
                    if (response.data.succeeded) {
                        toast.success(
                            <div>
                                <i className="fal fa-check-circle"></i>&nbsp;{this.props.t('profile.assignments.form.submit.success.create', {email: email.value})}
                            </div>
                        );

                        this.props.history.push('/profile');
                    }
                    if (response.data.errors) {
                        let errorMessages = [];
                        {
                            Object.keys(response.data.errors).forEach(function (key) {
                                errorMessages.push(response.data.errors[key][0]);
                            })
                        }

                        toast.error(
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;
                                <small style={{lineHeight: '1.2', display: 'inline-block'}}>
                                    {errorMessages.join('\n\r')}
                                </small>
                            </div>
                        );
                    }
                }).catch(error => {
                    console.log('[ManageAccount.js] : Change password error in passwordChangedHandler()', error.message);
                    this.setState({loading: false});
                }
            );
        }
    }

    render() {
        const {
            subAccountsVisibility,
            itemId,
            loading
        } = this.state;

        const formElements = [];
        for (let key in this.state.form) {
            formElements.push({
                id: key,
                configs: this.state.form[key]
            })
        }

        return (
            <div className="flex flex--direction-column form assignment-content">
                <h2 className={"headline headline--section headline--uppercase"}>{this.props.t((itemId ? this.state.formEditTitle : this.state.formTitle))}</h2>

                {loading ? (
                    <div className="container flex flex-column justify-content-center align-items-center">
                        <Spinner/>
                    </div>
                ) :
                <div>
                    <h3 className={"headline--block headline"}>{this.props.t(this.state.formSubtitle)}</h3>
                    {formElements.map(element => (
                        <Input key={element.id}
                               form={this.state.form}
                               label={element.configs.label}
                               elementtype={element.configs.elementType}
                               elementconfigs={element.configs.elementConfigs}
                               value={element.configs.value}
                               valid={element.configs.valid}
                               shouldValidate={element.configs.validationRules}
                               touched={element.configs.touched}
                               changed={(element.configs.elementType == 'checkbox')? (event) => this.handleOnCheckedChange(event): (event) => this.inputChangedHandler(event, element.id)}
                               errorMessage={element.configs.errorMessage}/>
                    ))}

                    <div>
                        {subAccountsVisibility ? <SubAccountsList
                            onCheck={this.updateSelectedSubAccounts}
                            selectedValues={this.state.form['subaccounts'].value}/> : null}
                    </div>
                </div>}
                <div className="form__action">
                    <Link className="btn btn-primary btn-sm" to="/profile">
                        {this.props.t("profile.assignments.form.cancelbtn")}&nbsp;&nbsp;<i
                        className="fas fa-angle-right"></i>
                    </Link>
                    <button type="submit" className="btn btn--outline" disabled={!this.state.formIsValid}
                            onClick={this.saveRoleHandler}>
                        {this.props.t("profile.assignments.form.savebtn")}&nbsp;&nbsp;<i
                        className="fas fa-angle-right"></i>
                    </button>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Form);
